import {
  AfterViewInit,
  Component,
  inject,
  Input,
  OnChanges,
  OnInit,
  signal,
  SimpleChanges,
} from "@angular/core";
import { ApexNonAxisChartSeries, ApexOptions } from "ng-apexcharts";
import {
  AxisChartData,
  NonAxisChartData,
} from "src/app/services/model/apex-chart.model";

@Component({
  selector: "app-column-chart",
  standalone: false,
  templateUrl: "./column-chart.component.html",
  styleUrl: "./column-chart.component.scss",
})
export class ColumnChartComponent implements OnChanges, OnInit {
  @Input() set data(value: AxisChartData | NonAxisChartData) {
    if (value) {
      this.chartData.update(() => value);
      // setTimeout(() => {
      //   this.initChart();
      // }, 100);
    }
  }

  @Input() chartName: string = "chart-column";
  @Input() chartLabel: string = "Label";
  @Input() valueLabel: string = "";
  @Input() height: number = 320;
  @Input() ss: number = 60;
  @Input() chartLabelSize: number = 24;
  @Input() valueLabelSize: number = 14;
  @Input() chartLabelWeight: number = 700;
  @Input() valueLabelWeight: number = 600;

  @Input() showLabel: boolean = true;
  @Input() showValue: boolean = true;

  public chartOptions: Partial<ApexOptions>;

  // Metronic's yellow / red / blue: red reads as an error in a chart that has
  // no errors in it, and none of the three belong to this skin. These are the
  // demo's own hues stepped dark enough to sit on white — checked for lightness
  // band, chroma, contrast and colour-blind separation rather than picked by eye.
  // The 2021 palette, not the indigo/amber/teal trio this shipped with — those
  // were three hues from three different systems, and they were the loudest
  // thing on a page that is otherwise entirely sky blue. Ordered dark → light →
  // gold so the series stay apart by VALUE as well as by hue, which is what
  // keeps a bar chart readable when it is printed, screenshotted or looked at
  // by somebody who does not separate blue from green.
  barColor = ["#0c557d", "#53bdee", "#ffc347"];
  chartData = signal<AxisChartData | NonAxisChartData | null>(null);

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.initChart();
    }
  }
  ngOnInit(): void {
    // this.initChart();
  }

  initChart() {
    this.chartOptions = {
      series: this.chartData()?.series as ApexNonAxisChartSeries,
      chart: {
        height: this.height,
        type: "bar",
        width: "100%",
        events: {
          dataPointSelection: () => false, // ป้องกัน event click
        },
        toolbar: {
          show: false,
        },
        // events: {
        //   dataPointSelection: (event, chartContext, config) => {
        //     // do nothing
        //     event.preventDefault(); // ป้องกัน action
        //   },
        // },
      },

      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          borderRadius: 8,
          borderRadiusApplication: "end",
        },
      },

      stroke: {
        show: true,
        width: 3,
        colors: ["transparent"],
      },
      fill: {
        colors: this.barColor,
      },
      /* The value printed on the bar takes its colour from the bar it sits on.
       * ApexCharts defaults every data label to white, which is ~1.9:1 on the
       * sky bar and ~1.6:1 on the gold one — only the navy series was legible.
       * Order matches `barColor`. */
      dataLabels: {
        // Off on a phone. Three series in a group leaves each bar ~9px wide at
        // 390px, so the numbers overlapped into "0.6.6" and "1.4.4" and one of
        // them dropped out entirely. The tooltip still gives the exact value.
        enabled: typeof window !== "undefined" ? window.innerWidth >= 768 : true,
        style: {
          colors: ["#ffffff", "#242424", "#242424"],
          fontSize: "12px",
          fontWeight: 600,
        },
      },
      xaxis: {
        categories: this.chartData()?.labels,
        labels: {
          style: {
            fontSize: "12px",
            colors: ["#444444"], // สีของ label
            fontWeight: 600,
          },
          rotate: -45, // หมุน label
          formatter: (value) => `วันที่ ${value}`, // แปลงข้อความก่อนแสดง
        },
      },
      yaxis: {
        labels: {
          style: {
            fontSize: "12px",
            colors: ["#444444"], // สีของ label
            fontWeight: 500,
          },
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "" + val + "";
          },
        },
      },
    };
  }

  getValueLabel(val: number): string {
    return this.valueLabel.length ? this.valueLabel : val.toString();
  }
}
